import { Divider, Stack, Typography } from '@mui/material';

import CopyToClipboardButton from '../buttons/copyToClipboardButton';

export default function CopyableCode({
  title,
  code,
  codeClassName,
}: {
  code: string;
  codeClassName?: string;
  title?: string;
}) {
  if (title) {
    return (
      <Stack
        className='w-full p-[16px] bg-gray-100 rounded-[16px]'
        divider={<Divider sx={{ borderStyle: 'dashed' }} />}
        gap='12px'
      >
        <Stack
          direction='row'
          gap='8px'
          alignItems='center'
          justifyContent='space-between'
        >
          <Typography variant='subtitle1'>{title}</Typography>
          <CopyToClipboardButton textToCopy={code} />
        </Stack>
        <code
          className={` text-black break-pretty w-full whitespace-pre overflow-x-auto text-[14px] ${
            codeClassName ?? ''
          }`}
        >
          {code}
        </code>
      </Stack>
    );
  }

  return (
    <Stack
      direction='row'
      gap='8px'
      alignItems='start'
      className='w-full p-[24px] bg-gray-100 rounded-[16px]'
    >
      <code
        className={` text-black break-pretty w-full whitespace-pre overflow-x-auto text-[14px] ${
          codeClassName ?? ''
        }`}
      >
        {code}
      </code>
      <CopyToClipboardButton textToCopy={code} />
    </Stack>
  );
}
